import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { FieldComponent } from '../../field/field.component';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import { Base } from 'src/app/services/base';


@Component({
    selector: 'app-pin-description',
    templateUrl: './pin-description.component.html',
    styleUrls: ['./pin-description.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PinDescriptionComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<FieldComponent>,
    public dialog: MatDialog,
    public base: Base,
    public translate: TranslateService) { }

  pinForm = new FormGroup({
    newDescription: new FormControl('', Validators.required)
  });

  ngOnInit(): void {
    if (this.data != null) {
      if (this.data.id > 0) {
        this.pinForm.setValue({ newDescription: this.data.title });
      }
    }
  }

  onSubmit() {
    var newDes = this.pinForm.controls.newDescription.value;

    this.dialogRef.close({ "newDes": newDes, "type": "save" });
  }

  cancel() {
    this.dialogRef.close({ "newDes": "", "type": "cancel" });
  }

}
